module.exports = fox._r("images/header-v-line.png", __webpack_public_path__ + "_/_/_/common/frame/images/header-v-line.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/header-v-line.png
// module id = 124
// module chunks = 2